import { FunctionComponent } from 'react';
import qs from 'qs';

import { Logo } from '../Logo';

import classes from './navbar.module.scss';

export const NavBar: FunctionComponent = () => {
  const { app: isApp } = qs.parse(window.top?.location.search.slice(1) || '');

  if (isApp === 'true') {
    return null;
  }

  return (
    <nav className={classes.navbar}>
      <div className={classes.brand}>
        <a
          href={'https://www.lagostina.it'}
          target={'_blank'}
          rel={'noreferrer noopener'}
        >
          <Logo />
        </a>
      </div>
    </nav>
  );
};
